export const blockIconsEditorTableChart = (
	<span className='material-symbols-outlined'>table_chart</span>
);
